module.exports = __webpack_public_path__ + "img/Belano.06ec6b55.jpeg";